/* eslint-disable react/jsx-pascal-case */
import { FilterCriteria__REFACTORED } from 'components/page/index';
import { Section } from 'components/ui/index';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

const propTypes = {
};

function CriteriaSection() {
  const i18n = 'page.ReportFilters';

  return (
    <Section title={<FormattedMessage id={`${i18n}.sectionNames.criteria`} />}>
      <FilterCriteria__REFACTORED
        theme="report"
        needSearchBar
      />
    </Section>
  );
}

CriteriaSection.propTypes = propTypes;
const mapStateToProps = ({ global }) => ({
  lang: global.language,
});
const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(CriteriaSection);



// WEBPACK FOOTER //
// ./src/views/ReportFilters/components/CriteriaSection.jsx